<template>
  <div class="row">
    <div class="col-xs-12 col-md-9 col-lg-8">
      <template v-if="resources.length > 0">
        <ResourcePreviewCard
          v-for="resource in resources"
          :key="resource.uuid"
          v-bind="resource"/>
      </template>
    </div>
  </div>
</template>

<script>
import ResourcePreviewCard from '@/components/ResourcePreviewCard'
import { mapState } from 'vuex'

export default {
    name: 'PresentLevelsConclusionAssessments',
    components: {
    ResourcePreviewCard,
    ResourcePreviewCard
},
    computed: {
        ...mapState('presentlevels', {
            resources: state => state.resourceDocs,
        })
    }
}
</script>
